import styles from "./styles";
import PropTypes from "prop-types";

const FormResponse = ({ heading, message, success, children }) => {
  const bannerProps = success
    ? {
        className: `${styles.banner} ${styles.success}`,
        role: "status",
        "aria-live": "polite",
      }
    : {
        className: `${styles.banner} ${styles.error}`,
        role: "alert",
        "aria-live": "assertive",
      };

  return (
    <div {...bannerProps}>
      <div className={styles.heading}>
        {success && (
          <svg
            className={styles.headingIcon}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            focusable="false"
          >
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="2"
            />
            <path
              d="M7.5 12.5l3 3 6-6.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
        <h2>{heading}</h2>
      </div>
      {message && <p>{message}</p>}
      {children}
    </div>
  );
};

export default FormResponse;

FormResponse.propTypes = {
  heading: PropTypes.string.isRequired,
  message: PropTypes.string,
  success: PropTypes.bool,
  children: PropTypes.node,
};
